export const TRANSLATION_GROUP_MIRRORS_CREATE_MANUALLY = Symbol('admin.mirrors-list.create-manually');

export const MIRRORS_LIST_CREATE_JS_MANUALLY_ROUTE_NAME = Symbol('admin.mirrors-list.create-manually-js');
export const MIRRORS_LIST_CREATE_NO_JS_MANUALLY_ROUTE_NAME = Symbol('admin.mirrors-list.create-manually-no-js');

export const MIRROR_CREATE_MANUALLY_MUTATION_KEY = 'mirror-create-manually-mutation-key';
export const MIRROR_CREATE_MANUALLY_MUTATION_API_URL = 'admin/mirrors';
